// Build 94b — formatera datum-intervall för evenemang (kommande/flerdagars).
// Returnerar svensk text, kompakt:
//   • Endag:        "4 jul 2026"
//   • Samma månad:  "4–6 jul 2026"
//   • Olika månad:  "30 jun – 2 jul 2026"
//   • Olika år:     "30 dec 2025 – 2 jan 2026"
//
// `start` och `end` är ISO-strängar "YYYY-MM-DD". `end` kan vara null/undefined/samma som start.

const MONTHS_SHORT = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

function parseISO(d) {
  if (!d) return null;
  // Tolka ISO "YYYY-MM-DD" deterministiskt i lokaltid utan timezone-shift.
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  return { y: Number(m[1]), m: Number(m[2]) - 1, d: Number(m[3]) };
}

export function formatEventDateRange(startISO, endISO) {
  const s = parseISO(startISO);
  if (!s) return "";
  const e = parseISO(endISO);
  // Endag (saknas eller samma datum)
  if (!e || (e.y === s.y && e.m === s.m && e.d === s.d)) {
    return `${s.d} ${MONTHS_SHORT[s.m]} ${s.y}`;
  }
  // Samma månad + år
  if (e.y === s.y && e.m === s.m) {
    return `${s.d}–${e.d} ${MONTHS_SHORT[s.m]} ${s.y}`;
  }
  // Samma år, olika månad
  if (e.y === s.y) {
    return `${s.d} ${MONTHS_SHORT[s.m]} – ${e.d} ${MONTHS_SHORT[e.m]} ${s.y}`;
  }
  // Olika år
  return `${s.d} ${MONTHS_SHORT[s.m]} ${s.y} – ${e.d} ${MONTHS_SHORT[e.m]} ${e.y}`;
}

// Build 94b — tid-intervall. `tid` är "HH:MM" eller redan en strängformaterad sträng som "10:00–17:00".
// Om både tid och tid_slut finns: "HH:MM–HH:MM". Annars returneras tid som-är.
export function formatEventTimeRange(tid, tidSlut) {
  if (!tid && !tidSlut) return "";
  const t = (tid || "").trim();
  const ts = (tidSlut || "").trim();
  // Bevara legacy-strängar som redan har "–" inbakad (t.ex. "10:00–17:00").
  if (t && /[–-]/.test(t) && !ts) return t;
  if (t && ts) return `${t}–${ts}`;
  return t || ts;
}

// Kombinerad helper: returnerar "4–6 jul 2026, 09:00–17:00".
export function formatEventWhen(event) {
  const date = formatEventDateRange(event?.datum, event?.datum_slut);
  const time = formatEventTimeRange(event?.tid, event?.tid_slut);
  return time ? `${date}, ${time}` : date;
}
